<template>
    <div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('targetSystem.rem.sender')}}</label>
            <div class="col-sm-9">
                <select v-model="value.RemProviderId" class="form-control" required>
                    <option v-for="rp in remProviders" :key="rp.Id" :value="rp.Id">{{rp.Name}} ({{rp.RemAddress}})</option>
                </select>
                <!-- <div class="form-help">Gönderimin yapılacağı KEP hesabınızı seçin. KEP hesapları, Tanımlar » KEP Hesapları menüsü altından tanımlanabilir.</div> -->
            </div>
        </div>

        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('targetSystem.rem.remAddress')}}:</label>
            <div class="col-sm-9">
                <vue-tags-input
                    v-model="to"
                    :tags="value.To || []"
                    :placeholder="translate('targetSystem.rem.remAddress')"
                    @tags-changed="newTags => value.To = newTags.map(x => x.text.toLowerCase())"
                    :save-on-key="[13]"
                    :seperators="[':', ';', ' ']"
                    :allow-edit-tags="true"
                    :allow-duplicates="false"
                    :addOnKey="[9, 13, 32, 44, 58, 59]"
                    @before-adding-tag="checkEmail"
                    @input="handleKEP"
                />
                <div class="text-right" v-show="!findRemBySearch">
                    <button @click="findByUnitName" type="button" class="btn btn-link" :title="translate('targetSystem.rem.findByUnitNameTitle')">{{translate('targetSystem.rem.findByUnitName')}}</button>
                </div>
            </div>       
        </div>
        <div class="form-group row" v-if="findRemBySearch">
            <label class="col-form-label col-sm-3">{{translate('targetSystem.rem.organizationName')}}</label>
            <div class="col-sm-9">
                <select-input
                    :value="selectedValue"
                    :autocomplete="true"
                    :placeholder="translate('search')"
                    :datasource="detsisUrl"
                    @change="setValue"
                    >
                        <span>{{selectedValue}}</span>
                        <template v-slot:item="{item}">
                            {{prepareDetsisDisplayName(item)}}
                        </template>
                </select-input>
                <div class="form-help">{{translate('targetSystem.rem.organizationSearchText')}}</div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('targetSystem.rem.detsisNo')}}</label>
            <div class="col-sm-9">
                <input v-model="value.DetsisNumber" @input="checkInput('DetsisNumber',$event)" type="text" class="form-control" />
                <div class="text-right" v-show="!findDetsisBySearch">
                    <button @click="findDetsisBySearch = true" type="button" class="btn btn-link" :title="translate('targetSystem.rem.findDetsisBySearchTitle')">{{translate('targetSystem.rem.findDetsisBySearch')}}</button>
                </div>
            </div>
        </div>
        <div class="form-group row" v-if="findDetsisBySearch">
            <label class="col-form-label col-sm-3">{{translate('targetSystem.rem.organizationName')}}</label>
            <div class="col-sm-9">
                <select-input
                    :value="selectedValue"
                    :autocomplete="true"
                    :placeholder="translate('search')"
                    :datasource="detsisUrl"
                    @change="setDetsisNumber"
                    >
                        <span>{{selectedValue}}</span>
                        <template v-slot:item="{item}">
                            {{prepareDetsisDisplayName(item)}}
                        </template>
                </select-input>
                <div class="form-help">{{translate('targetSystem.rem.organizationSearchDetsisText')}}</div>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('targetSystem.rem.subject')}}</label>
            <div class="col-sm-9">
                <input v-model="value.Subject" @input="checkInput('Subject',$event)" type="text" class="form-control" required />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('targetSystem.rem.barcodeNo')}}</label>
            <div class="col-sm-9">
                <input v-model="value.BarkodNo" type="text" class="form-control" />
            </div>
        </div>
        <div class="form-group">
            <label>{{translate('targetSystem.rem.body')}}</label>
            <text-area-input v-model="value.Body" className="form-control" :maxlength="2000" rows="4" required />
            <!-- <textarea v-model="value.Body" class="form-control" maxlength="2000" rows="4" required></textarea> -->
        </div>
        
    </div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';  // http://www.vue-tags-input.com/#/start
import axios from 'axios';
import selectInput from '../SelectInput.vue';
import TextAreaInput from '@/components/TextAreaInput.vue';

export default {
    components: {
        VueTagsInput,
        selectInput,
        TextAreaInput,
    },
    props: ['value'],
    data(){
        return {
            findRemBySearch :false,
            findDetsisBySearch: false,
            tags: [], 
            selectedValue:'',
            to: '',
            remProviders: []
        }
    },
    created(){
        axios.post("remprovider/selectlist").then(x => { 
            this.remProviders = x.data; 
        }).catch(x => {
            console.log("KEP listesi yüklenemedi:", x);
        });
    },
    computed: {
        detsisUrl(){
            return window.settings.detsisApiUrl + "Detsis/filterByName";
        },
    },
    methods: {
        prepareDetsisDisplayName(item){
            var ustKurum = item.KurumHiyerarsik;
            var replaced = ustKurum.replace(item.Ad,'').trim();
            if(replaced.endsWith('>'))
                replaced = replaced.replace(new RegExp('>' + '$'), '').trim();
            if(replaced)
                replaced = ' ('+replaced+')';
            return item.Ad+ replaced;
        },
        handleKEP(newTo) {
            if (/[<>]/.test(newTo)) {
                alert(this.translate('errors.invalidSymbols'));
                this.$nextTick(() => {
                this.to = '';
                });
            } else {
                this.to = newTo;
            }
        },
        checkInput(val, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.value, val, editedText)
            } else {
                this.$set(this.value, val, event.target.value)
            }
        },
        checkEmail(obj){
            if(window.settings.isTestMode) {
                obj.addTag();
                return;
            }

            var exp = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if (!obj.tag.text.match(exp))
                return;
            else if(!obj.tag.text.match(/\.kep\.tr$/)) {
                alert(this.translate('errors.invalidExtensionForKepTarget'));
                return;
            }
            else
                obj.addTag();
        },
        async setDetsisNumber(val){
            this.selectedValue = val.Ad;
            this.value.DetsisNumber = val?.DETSISNo;
            this.findDetsisBySearch = false;
        },
        async  setValue(val){
            this.selectedValue = val.Ad;
            this.value.DetsisNumber = val?.DETSISNo;
            var tempVal;
            const remAddress = await  this.getDetsisUnitRem(val.DETSISNo).then(x=> { 
                if(x.data.Data == null){
                    alert(this.translate('errors.organizationNotPresentInKaysis'));
                    console.log(tempVal);
                    tempVal = '';
                } else if(!x.data.Data.Aktifmi) {
                    alert(this.translate('errors.activeKepAccountNotFoundForOrganization'));
                    tempVal = '';
                } else { 
                    tempVal = x.data.Data.KepAdresi; 
                }
                return tempVal;
            }); 
            if(remAddress) {
                console.log('remAddress: ', remAddress);

                if(!this.value.To)
                    this.value.To = [];

                if(typeof this.value.To === 'string')
                    this.value.To = [this.value.To];

                this.value.To = this.value.To.filter(x => x != remAddress);

                this.value.To.push(remAddress);
                this.findRemBySearch = false;
                this.selectedValue = '';
                this.$forceUpdate();
            }
        },
        findByUnitName(){
            this.findRemBySearch = true;
        }
    }
}

</script>
